/**
 * Plan tier.
 *
 * NOTE: there is no billing/subscription table in schema.sql yet, so there is
 * nothing authoritative to read. Until one exists, everyone is treated as being
 * on the free plan and the upgrade cards are shown.
 *
 * When billing lands, give this one place a real source of truth — every
 * upgrade CTA in the app routes through `isFreePlan`.
 */
export function isFreePlan(recipient) {
  const tier = recipient?.plan_tier ?? recipient?.subscription_tier ?? null
  if (!tier) return true
  return String(tier).toLowerCase() === 'free'
}

export const PLANS = [
  {
    key: 'connect',
    name: 'MaPa Connect',
    price: '$197',
    cadence: '/month',
    blurb: 'A coordinator calls Ma or Pa every morning and logs the check-in here.',
  },
  {
    key: 'plus',
    name: 'MaPa Plus',
    price: '$397',
    cadence: '/month',
    blurb: 'Daily calls plus a monthly nurse assessment and a doctor-ready summary.',
  },
]
